/*
  Scroll reveals, without a framework.
  ---------------------------------------------------------------------------
  Replaces Motion, which cannot run in a Liquid theme. An IntersectionObserver
  marks elements shown once, and CSS does the transition, so the animation runs
  off the main thread.

  It fails open by design. The hidden state in base.css is scoped to
  html[data-reveal-ready], and that attribute is only set here. If this script is
  blocked, never parses, or the browser has no IntersectionObserver, nothing is
  ever hidden and the page reads normally. That matters more on a marketing site
  than the animation does.
*/
(function () {
  var root = document.documentElement;

  var reduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // No observer support or reduced motion: leave everything visible, do nothing.
  if (reduced || !('IntersectionObserver' in window)) return;

  root.setAttribute('data-reveal-ready', '');

  function show(el) {
    // Stagger siblings so a group cascades instead of arriving as one slab.
    var delay = parseFloat(el.getAttribute('data-reveal-delay') || '0');
    if (delay > 0) {
      window.setTimeout(function () {
        el.setAttribute('data-shown', '');
      }, delay * 1000);
    } else {
      el.setAttribute('data-shown', '');
    }
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        show(entry.target);
        io.unobserve(entry.target);
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );

  function observeAll() {
    var targets = document.querySelectorAll('[data-reveal]:not([data-shown]), .img-reveal:not([data-shown])');
    for (var i = 0; i < targets.length; i++) io.observe(targets[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeAll);
  } else {
    observeAll();
  }

  // The theme editor swaps section markup in without a page load.
  document.addEventListener('shopify:section:load', observeAll);

  /*
    Safety net. If an element is already past the viewport on load, some browsers
    report it as not intersecting and it would stay hidden forever. Reveal
    anything sitting above the fold line after a beat.
  */
  window.setTimeout(function () {
    var stragglers = document.querySelectorAll('[data-reveal]:not([data-shown]), .img-reveal:not([data-shown])');
    for (var i = 0; i < stragglers.length; i++) {
      var box = stragglers[i].getBoundingClientRect();
      if (box.top < window.innerHeight) show(stragglers[i]);
    }
  }, 1200);
})();
